export enum MemberType {
  OWNER = 'owner',
  MANAGER = 'manager',
  WATCHER = 'watcher'
}
